import React from 'react';
import { NeoReport, Report } from "@singularsystems/neo-reporting";
import { MaintenanceReportCategories } from '../MaintenanceReportCategories';
import { Layout } from '@singularsystems/neo-canvas-grid';
import EventsNotInConfigurationTableReportCriteria from './EventsNotInConfigurationTableReportCriteria';


@NeoReport("EventsNotInConfigurationTableWIP",  { category: MaintenanceReportCategories.DataValidationReports})
export default class EventsNotInConfigurationTableReport extends Report<EventsNotInConfigurationTableReportCriteria>{

    constructor() {
        super(EventsNotInConfigurationTableReportCriteria);
    }

    public renderCriteria() {
        return (
        <>
        </>);
    }

    public getDefaultGridLayout() {
        return {
            "root": {
            }
        } as Layout.IGridLayout;
    }
}